import { palette } from '../theme/palette'

interface QRColorsInterface {
  textColor: string
  borderColor: string
  backgroundColor: string
  clickedBackgroundColor: string
  clickedBorderColor: string
  focusBackgroundColor: string
  focusBorderColor: string
}

export const quickRepliesColorStylesSetter = (attributeValue: string, qrColors: QRColorsInterface, setQrColors: (props: QRColorsInterface) => void) => {

  switch (attributeValue.toLowerCase()) {
    case 'primary':
      setQrColors({
        ...qrColors,
        'textColor': palette.white,
        'borderColor': palette.mainBlue,
        'backgroundColor': palette.mainBlue,
        'clickedBackgroundColor': palette.primaryClickState,
        'clickedBorderColor': palette.primaryClickState,
        'focusBackgroundColor': palette.primaryFocusState,
        'focusBorderColor': palette.mainBlue
      })
      break
    case 'secondary':
      setQrColors({
        ...qrColors,
        'textColor': palette.mainBlue,
        'borderColor': palette.mainBlue,
        'backgroundColor': palette.white,
        'clickedBackgroundColor': palette.secondaryClickState,
        'clickedBorderColor': palette.mainBlue,
        'focusBorderColor': palette.mainBlue
      })
      break
    case 'cta':
      setQrColors({
        ...qrColors,
        'textColor': palette.white,
        'borderColor': palette.ctaButtonSalmon,
        'backgroundColor': palette.ctaButtonSalmon,
        'clickedBackgroundColor': palette.ctaClickState,
        'clickedBorderColor': palette.ctaClickState,
        'focusBackgroundColor': palette.ctaFocusState,
        'focusBorderColor': palette.mainBlue
      })
      break
    default:
      setQrColors({
        ...qrColors,
        'textColor': palette.mainBlue,
        'borderColor': palette.mainBlue,
        'backgroundColor': palette.white,
        'clickedBackgroundColor': palette.secondaryClickState,
        'clickedBorderColor': palette.mainBlue
      })
  }
}
